<div class="footer-container">
  <div class="text-right">
    <span class="small mr-3">
      &copy;{{ year }} Alpi USA Inc. All rights reserved.
    </span>
    <a href="https://www.facebook.com/alpiworld" target="_blank" class="mr-2">
      <img src="../../../../assets/icons/facebook.svg" alt="Facebook" />
    </a>
    <a href="https://www.linkedin.com/company/albini-&-pitigliani---alpiworld" target="_blank" class="mr-4">
      <img src="../../../../assets/icons/linkedin.svg" alt="LinkedIn" />
    </a>
  </div>
</div>
